import { RouteEntry } from "../../../shared/routes";
import { IdentityRoles } from "../../../configure/security/IdentityRoles";
import { SubscriptionTrainingModulesList } from "./SubscriptionTrainingModulesList";

export const subscriptionTrainingModuleAssessmentRoutes: Array<RouteEntry> = [
    { path: '/administration/subscriptions/details/:subscriptionId/training', exact: true, component: SubscriptionTrainingModulesList, authorize: true, requireRole: IdentityRoles.Administration },
];
